import React from 'react';

import ErrorIcon from '@atlaskit/icon/core/status-error';
import { CheckboxOption } from '@atlaskit/select/checkbox-option';
import { RadioOption } from '@atlaskit/select/radio-option';
import type { OptionProps, OptionType } from '@atlaskit/select/types';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip/Tooltip';

import { StyledInvalidCheckboxOption } from '../../../../common/ui/picker/styled';

type CheckboxOptionProps = OptionProps<OptionType, true>;
type RadioOptionProps = OptionProps<OptionType, false>;

const renderOption = (props: OptionProps<OptionType, boolean>): React.JSX.Element =>
	props.isMulti ? (
		<CheckboxOption {...(props as CheckboxOptionProps)} />
	) : (
		<RadioOption {...(props as RadioOptionProps)} />
	);

export const Option = (props: OptionProps<OptionType, boolean>): React.JSX.Element => {
	if (props.data?.invalid) {
		return (
			<StyledInvalidCheckboxOption>
				{renderOption(props)}
				<Tooltip content={props.selectProps.fieldInvalidLabel}>
					<ErrorIcon label="Test" color={token('color.icon.danger')} />
				</Tooltip>
			</StyledInvalidCheckboxOption>
		);
	}

	return renderOption(props);
};
